<template>
  <div>
    <div>
      <el-row :gutter="24">
        <el-col :span="4">
          <el-input placeholder="商家id" v-model="params.merchant_id" style="width: 100%" size="mini"> </el-input>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="订单id" v-model="params.order_id" style="width: 100%" size="mini">
          </el-input>
        </el-col>
        <el-col :span="6">
            <div class="block">
                <el-date-picker size="mini" v-model="params.times" clearable type="daterange"
                    :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" align="right">
                </el-date-picker>
            </div>
        </el-col>
        <el-col :span="7">
          <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
             <el-button type="primary" size="mini" icon="plus" @click="getExport()">导出数据</el-button>
        </el-col>
      </el-row>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="created_at" label="时间"></el-table-column>
        <el-table-column prop="order_id" label="订单id"></el-table-column>
        <el-table-column prop="merchant_id" label="商家id"></el-table-column>
        <el-table-column prop="transfer_no" label="云商通转账订单号"></el-table-column>
        <el-table-column prop="biz_transfer_no" label="商户系统转账订单号"></el-table-column>
        <el-table-column prop="amount" label="金额">
          <template slot-scope="scope">
            {{scope.row.amount/100}}
          </template>
        </el-table-column>
        <el-table-column  label="支付状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.order_status == 'PAYED' ">已支付</el-tag>
            <el-tag type="danger" v-else>已退款</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]"
          :total="total_count" :page-size="params.pagesize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import draggable from "vuedraggable";
  import {
    getMerchantTransfer,
    getMerchantTransferExport
  } from "../../../api/merchant";
  export default {
    components: {
      draggable
    },
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dialogVisible: false,
        total_count: 0,
        params: {
          page: 1,
          pagesize: 20,
        },
        dataList: [],
        loading: false,
        id: "",
        row: [],
        moneyList: [],
        title: '',
      };
    },
    computed: {
      ...mapGetters(["wheight"]),
    },
    methods: {

      getDataList() {
        this.loading = true;
        getMerchantTransfer(this.params)
          .then((response) => {
            this.dataList = response.data.data.list;
            this.total_count = response.data.data.total_count;
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: "error",
              message: "获取列表信息出错",
            });
          });
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num;
        this.getDataList();
      },
      searchData() {
        this.params.page = 1;
        this.getDataList();
      },
      handleSizeChange(pageSize) {
        this.params.page = 1;
        this.params.pagesize = pageSize;
        this.getDataList();
      },
      show(row) {
        this.dialogFormVisible = true;
        this.row = row;
      },
      //export
      getExport() {
          this.$notify({
              title: '成功',
              message: '正在导出,请稍后...',
              type: 'success'
          })

          getMerchantTransferExport(this.params).then(res => {
              if (res.data.data.status) {
                  this.$notify({
                      title: '成功',
                      message: '已加入队列,请到设置中下载!',
                      type: 'success!'
                  })
                  // var url = res.data.data.url
                  // window.open(url)
              } else {
                  this.$notify({
                      title: '失败',
                      message: '出错了!',
                      type: 'error'
                  })
              }
          })


      },
    },
    mounted() {

      this.getDataList();

    },
  };
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// list.vue?378e06f2